import { observer } from 'mobx-react-lite';
import { Button } from '@mui/material';
import { useClinicalEventsModal } from '../Drawer/Provider';
import useRtmEventsService from '../service';
import { useParams } from 'react-router';
import styles from '../index.module.scss';

const AmendClinicalEvent = ({ uuid }: { uuid: string }) => {
  const { setContextData } = useClinicalEventsModal();
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  const { allowAmmend } = useRtmEventsService(patientUuid)

  const amendEvent = () => setContextData({ clinicalEventUuid: uuid });
  return (
    <Button
      variant={'outlined'}
      disabled={!allowAmmend(uuid)}
      color="primary"
      className={styles.amend}
      onClick={amendEvent}>
      Amend
    </Button>
  );
};

export default observer(AmendClinicalEvent);
